import React from 'react';
import { Cards, ImageIconCardProps } from './ImageIconCard.model';
import './ImageIconCard.scss';

import ubuntu from '../../../../../../assets/images/apps/ubuntu.png'
import windows from '../../../../../../assets/images/apps/windows.png'
import cpanel from '../../../../../../assets/images/apps/cpanel.png'
import rocky from '../../../../../../assets/images/apps/rocky.png';
import alma from '../../../../../../assets/images/apps/alma.png';
import debian from '../../../../../../assets/images/apps/debian.png';
import { Badge } from '@/components/Dumb/Molecules/Badge/Badge';
import DesignTokens from 'uol-host-react-ui/dist/shared/DesignTokens.styles';

interface imageIcon {
    name: string,
    shortname: Cards,
    srcImage: string
}

const ImageIconCard: React.FC<ImageIconCardProps> = (props: ImageIconCardProps) => {
    const groupsImages: imageIcon[] = [{
        name: 'Ubuntu',
        shortname: Cards.ubuntu,
        srcImage: ubuntu
    },
    {
        name: 'Windows',
        shortname: Cards.windows,
        srcImage: windows
    },
    {
        name: 'cPanel',
        shortname: Cards.cpanel,
        srcImage: cpanel
    },
    {
        name: 'Rocky Linux',
        shortname: Cards.rocky,
        srcImage: rocky
    },
    {
        name: 'AlmaLinux',
        shortname: Cards.alma,
        srcImage: alma
    },
    {
        name: 'Debian',
        shortname: Cards.debian,
        srcImage: debian
    }
    ]

    return (
        <>
            {(props.layout === 'card') &&
                <div role="tablist" aria-orientation="horizontal" className="list-cards d-flex justify-content-between">
                    {groupsImages.map((val) => {
                        return (
                            <button
                                key={val.name}
                                className="d-flex flex-column"
                                role="tab"
                                aria-controls={`panel-id-${val}`}
                                aria-selected={props.cardChecked === val.shortname}
                                id={`tab-id-${val}`}
                                onClick={() => {
                                    props.setCardChecked(val.shortname);
                                }}
                            >
                                <div className={`card  ${(props.cardChecked === val.shortname) ? "checked" : ""}`} >
                                    <div className="card-body align-self-center">
                                        {(val.shortname === Cards.debian) &&
                                            <div className='badge'>
                                                <Badge backgroundColor={DesignTokens.color.ghost_uh} textColor='white' text='Novo' />
                                            </div>
                                        }
                                        <div className="icon">
                                            <img key={val.shortname} className={val.shortname} src={val.srcImage} alt="" />
                                        </div>
                                    </div>

                                    <p className="align-self-center">{val.name}</p>
                                </div>

                            </button>
                        )
                    })}
                </div>
            }
        </>
    )
}

export default ImageIconCard
